<!-- AI商务社交：创作者审核中心（复用短视频创作者审核页 / 同一 API） -->
<template>
  <ShortVideoCreator />
</template>
<script setup lang="ts">
import ShortVideoCreator from '@/views/shortvideo/creator/index.vue'

defineOptions({ name: 'BossCircleCreatorAudit' })
</script>
